/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../../Helpers/history';
import config from '../../Helpers/config.json';
import * as snackbarActions from '../../Redux/Actions/SnackbarActions/SnackbarActions';
import ReusableDashboardHeader from '../../Containers/Dasboard/ReusableDashboardHeader';
import PharmacySnackbar from '../../Utils/Snackbars/SnackbarUtil';
import ProformaInvoiceContent from './ProformaInvoiceContent';
import { useCustomA4Print } from '../../Utils/Template/useCustomA4Print';
import { errorMessages } from '../../Helpers/ErrorMessages';
import { BackButton } from "../../Utils/Buttons/DataExportationButton";

const BigProformaInvoice = ({ actions, snackbars, match: { params } }) => {
  const [data, setData] = useState({ products: [], customer: {} });
  const [loading, setLoading] = useState('idle');
  const { id } = params;

  const { handlePrint, componentRef } = useCustomA4Print(`Proforma_${id}`);

  useEffect(() => {
    if (!id) return;

    setLoading('pending');

    axios.get(`${config.epharmUrl}/Cinvoice/proforma_invoice/${id}`)
      .then(response => {
        const res = response.data;
        if (res.status === 200 && res.data) {
          const inv = res.data;
          setData({
            products: inv.products || [],
            customer: {
              ...inv,
              invoice_number: inv.proforma_invoice_number || inv.proforma_invoice_id,
              customer_name: inv.customer_name || "Customer",
              date: inv.date,
              total_amount: inv.total_amount,
            }
          });
          setLoading('resolved');
        }
      })
      .catch(error => {
        errorMessages(error, null, actions);
        setLoading('rejected');
      });
  }, [id, actions]);

  const { variant, message, open } = snackbars;
  const { products, customer } = data;

  return (
    <div>
      <ReusableDashboardHeader
        component="Big Proforma Invoice"
        heading="Proforma Invoice"
        subHeading="A4 Proforma Document"
        link={history.location.pathname}
      />

      <PharmacySnackbar
        open={open}
        variant={variant}
        message={message}
        handleCloseBar={() => actions.snackbarActions.hideSnackBar()}
      />

      <div className="d-flex justify-content-between mb-3 mr-5">
        <button onClick={handlePrint} className="btn btn-primary">
          Print Proforma Invoice
        </button>
        <BackButton to="/proforma-invoices" text="Back to Proforma List" />
      </div>

      {loading === 'pending' && (
        <div className="text-center mt-5">
          <img src="/images/listPreloader.gif" alt="loader" style={{ width: '10%' }} />
        </div>
      )}

      {loading === 'resolved' && (
        <div ref={componentRef} id="customA4Print">
          <ProformaInvoiceContent 
            customer={customer} 
            products={products} 
          />
        </div>
      )}

      {loading === 'rejected' && (
        <div className="text-center mt-5 text-danger">Failed to load Proforma Invoice</div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({ snackbars: state.snackbars });
const mapDispatchToProps = dispatch => ({
  actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) }
});

export default connect(mapStateToProps, mapDispatchToProps)(BigProformaInvoice);